import type { IBankAccount } from 'v2/interfaces/financial';

import { apiServiceProxy } from './api-proxy';
import type { ApiServiceProxy } from './api-proxy';

class BankDetailsService {
  constructor(private readonly apiService: ApiServiceProxy) {}
  public listBankDetails = () => {
    return this.apiService.get<IBankAccount[]>('/fundtransfers').then(response => response.data);
  };
  public setMainAccount = (accountId: number) => this.apiService.post(`/fundtransfers/${accountId}/make-main`, {});
  public deleteAccount = (accountId: number) => this.apiService.delete(`/fundtransfers/${accountId}`, {});
}

const bankDetailsService = new BankDetailsService(apiServiceProxy);
export default bankDetailsService;
